
import { FieldType } from "@/models";
import { FileText, Calendar, ListFilter, Info, Upload, PenLine, Pen } from "lucide-react";
import React from "react";

export const getFieldIcon = (type: FieldType) => {
  switch (type) {
    case 'text':
      return <FileText className="h-4 w-4 text-green-500" />;
    case 'date':
      return <Calendar className="h-4 w-4 text-amber-500" />;
    case 'select':
      return <ListFilter className="h-4 w-4 text-cyan-500" />;
    case 'information':
      return <Info className="h-4 w-4 text-blue-500" />;
    case 'file':
      return <Upload className="h-4 w-4 text-red-500" />;
    case 'signature':
      return <PenLine className="h-4 w-4 text-violet-500" />;
    case 'initials':
      return <Pen className="h-4 w-4 text-indigo-500" />;
    default:
      return <FileText className="h-4 w-4 text-gray-500" />;
  }
};

export const fieldTypeOptions = [
  { label: "Text", value: "text", icon: <FileText className="h-4 w-4 text-green-500" /> },
  { label: "Date", value: "date", icon: <Calendar className="h-4 w-4 text-amber-500" /> },
  { label: "Select", value: "select", icon: <ListFilter className="h-4 w-4 text-cyan-500" /> },
  { label: "Information", value: "information", icon: <Info className="h-4 w-4 text-blue-500" /> },
  { label: "File Upload", value: "file", icon: <Upload className="h-4 w-4 text-red-500" /> },
  { label: "Signature", value: "signature", icon: <PenLine className="h-4 w-4 text-violet-500" /> },
  { label: "Initials", value: "initials", icon: <Pen className="h-4 w-4 text-indigo-500" /> }
];
